import isMobile from 'is-mobile';
import { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import MenuWithLogo from '~/modules/Elements/MenuWithLogo';
import useSmoothNavigate from '~/modules/hooks/useSmoothNavigate';
import SuggestMobileMode from '~/routes/QuickSetup/SuggestMobileMode';
import SelectInputView from '~/routes/SelectInput/SelectInputView';
import { MobilePhoneModeSetting, useSettingValue } from '~/routes/Settings/SettingsState';

function QuickSetup() {
  const [mobilePhoneMode] = useSettingValue(MobilePhoneModeSetting);
  const isMobileDevice = useMemo(() => isMobile(), []);

  const navigate = useSmoothNavigate();
  const onFinish = () => {
    navigate('');
  };

  return (
    <>
      <Helmet>
        <title>Select Input | fastKaraoke</title>
      </Helmet>
      {mobilePhoneMode === null && isMobileDevice ? (
        <SuggestMobileMode />
      ) : (
        <MenuWithLogo>
          <SelectInputView onFinish={onFinish} closeButtonText="Sing a song" smooth />
        </MenuWithLogo>
      )}
    </>
  );
}

export default QuickSetup;
